module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "element element-non-bodymatter element-container-single element-type-preface element-with-heading",
    attrs: {
      "epub:type": "preface",
      "id": "preface",
      "role": "doc-preface"
    }
  }, [_c('div', {
    staticClass: "heading heading-with-title heading-without-image",
    attrs: {
      "id": "preface-heading"
    }
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("A Note from the Publishers")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "preface-text"
    }
  }, [_c('p', {
    staticClass: "first first-in-chapter first-full-width"
  }, [_vm._v("We each knew Kevin O’Donnell, Jr. in our separate ways. Thirty years ago, when we were just dating, Rebecca—an avid reader—was a big fan of his charming McGill Feighan series, while Kevin knew him as “the other Kevin” in the San Francisco Bay Area writing community.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Because both Kevins often appeared together at book signings and science fiction conventions, they were frequently mistaken for each other, earning the nicknames of “Odie” (for O’Donnell) and “Andie” (for Anderson). Andie even sat in on several writers’ workshop sessions with Odie for his last published novel, "), _c('i', [_vm._v("Fire on the Border ")]), _vm._v("(1990). Andie even earned brownie points by introducing Odie to his starry-eyed girlfriend Rebecca.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kevin O’Donnell, Jr.’s first novel, "), _c('i', [_vm._v("Bander Snatch")]), _vm._v(", was published in 1979, and his last, "), _c('i', [_vm._v("Fire on the Border")]), _vm._v(", just over ten years later. He died of lung cancer in 2012.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("Kevin was not a prolific writer, but he was a good friend. For two years, 1979–1981, he was managing editor for the seminal magazine "), _c('i', [_vm._v("Empire for the SF Writer")]), _vm._v(", and he dedicated many years volunteering his work in the Science Fiction Writers of America. The Service to SFWA Award was even named after him.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("His novels remained out of print for many years, and as publishers of WordFire Press, we are pleased to reissue many of those great books for a new audience. Keep in mind that the stories were all written four decades ago; societal attitudes and especially technical terms may seem a little dated. We did not want to rewrite Kevin’s work, so all of these new editions are presented in his original words, the way he wrote them.")]), _vm._v(" "), _c('p', {
    staticClass: "subsq"
  }, [_vm._v("We hope you enjoy these wonderful stories from one of science fiction’s unsung authors of the 1980s.")]), _vm._v(" "), _c('div', {
    staticClass: "alignment-block alignment-block-align-right"
  }, [_c('div', {
    staticClass: "text-block"
  }, [_c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("—Kevin J. Anderson and Rebecca Moesta, publishers")]), _vm._v(" "), _c('p', {
    staticClass: "alignment-block-content alignment-block-content-right"
  }, [_vm._v("WordFire Press")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18296c3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/anotefromthepublishers.vue
// module id = 72
// module chunks = 0